import { Picture } from '@ui';
import StoreInfoSchedule from '@components/AddressSelection/StoreInfo/components/StoreInfoSchedule';
import { transformScheduleToStoreInfoSchedule } from '@utils/processSchedule';
import { twcls } from '@utils/twcls';
import icons from '@icons';
import type { ShopFragmentMainEndpointFragment } from '@schema/main';
import type { FC } from 'react';

const StoreTypeTitles: Record<string, string> = {
  cafe: 'Кафе',
  oyster_bar: 'Гастроном | устричный бар',
  shop: 'Гастроном'
};

const {
  store: { black: storeBlackFilled },
  wine: { black: wineBlackFilled }
} = icons.Fill;

const StoreTypeIcons: Record<string, any> = {
  cafe: storeBlackFilled,
  oyster_bar: wineBlackFilled,
  shop: storeBlackFilled
};

interface PickupShopItemProps {
  item: ShopFragmentMainEndpointFragment;
  isActive: boolean;
  onSelect: (isShouldClose?: boolean) => void;
}

const PickupShopItem: FC<PickupShopItemProps> = ({
  item,
  isActive,
  onSelect
}) => (
  <div
    className={twcls('address-item', isActive && 'selected')}
    onClick={() => {
      onSelect();
    }}
  >
    <span className='block-address'>
      <div className='full-addres'>
        <div className='deliveryTitle'>
          {item.title}
          {!item.type && <div className='deliverySoon'>Скоро</div>}
        </div>
        {item.type && (
          <div className='deliveryType'>
            {StoreTypeTitles[item.type]}
            <Picture
              className='type-store-icon'
              icon={StoreTypeIcons[item.type]}
              height='12'
            />
          </div>
        )}
        <div className='deliveryAddress'>{item.address}</div>
        {item?.schedule && (
          <div className='deliveryTime'>
            <StoreInfoSchedule
              list={transformScheduleToStoreInfoSchedule(item?.schedule)}
              className='schedule-compact'
            />
          </div>
        )}
      </div>
    </span>
  </div>
);

export default PickupShopItem;
